import {
  TRACKER_MAXIMUM_WAVE_COUNT,
  TRACKER_MINIMUM_WAVE_COUNT,
} from '@ps/survey-utils';

export const TRACKER_CONFIG_DRAWER_TITLE = 'Set Up Your Survey Series';
export const TRACKER_CONFIG_DRAWER_SUBTITLE =
  "Based on your selection, we'll automatically configure recommended settings which you can adjust anytime";

export const TRACKER_CONFIG_DRAWER_TOOLTIPS = {
  numberOfWaves: 'Set the number of waves that you are planning to launch.',
  exclusionRule:
    'Set the respondent that can participate again in your recurring study.',
  waveFrequency:
    'Specify the launch frequency to auto-populate the schedule based on your initial live date. All waves default to a 7 AM launch time.',
} as const;

export const TRACKER_CONFIG_DRAWER_HELP_TEXTS = {
  numberOfWaves: `Most common: 3-5 waves, maximum ${TRACKER_MAXIMUM_WAVE_COUNT} waves. You can edit the number of waves later.`,
  waveFrequency:
    'Based on your launch date, subsequent waves will automatically be scheduled at your selected interval.',
};

export const TRACKER_CONFIG_FORM_MESSAGES = {
  NUMBER_OF_WAVES_REQUIRED: 'Number of waves is required.',
  NUMBER_OF_WAVES_RANGE: `Number of waves must be between ${TRACKER_MINIMUM_WAVE_COUNT} and ${TRACKER_MAXIMUM_WAVE_COUNT}.`,
  WAVE_FREQUENCY_REQUIRED: 'Wave frequency is required.',
  WAVE_FREQUENCY_MIN: 'Wave frequency must be at least 1.',
  WAVES_EXCLUDE_REQUIRED: 'This field is required.',
  WAVES_EXCLUDE_MIN: "Waves to exclude can't be negative.",
} as const;
